// @flow
import * as React from 'react';
import type { Element } from 'react';

import omit from 'lodash/omit';

import { StyledCover, StyledError } from './styles';

import type { Props } from './types';

const defaultInputComponent = props => <input {...props} />;

export default class Input extends React.PureComponent<Props> {
  get error(): ?string {
    const {
      form,
      field: { name }
    }: Props = this.props;
    const errors = form?.errors?.[name];
    return Array.isArray(errors) ? errors[0] : errors;
  }

  render(): Element<any> {
    const {
      field: { name, onChange, value },
      type,
      placeholder,
      inputComponent,
      displayName,
      id,
      white,
      ...rest
    }: Props = this.props;

    const InputComponent = inputComponent || defaultInputComponent;

    return (
      <StyledCover>
        <InputComponent
          {...omit(rest, 'form')}
          onChange={onChange}
          id={id || name}
          name={name}
          value={value}
          placeholder={placeholder}
          type={type || 'text'}
          white={white}
        />

        {this.error && <StyledError>{`${displayName} ${this.error}`}</StyledError>}
      </StyledCover>
    );
  }
}
